import { Suspense, lazy } from "react";
import { useLenis } from "@/hooks/useLenis";
import { Nav } from "@/components/landing/Nav";
import { Hero } from "@/components/landing/Hero";

const Ribbon = lazy(() => import("@/components/landing/Ribbon").then((m) => ({ default: m.Ribbon })));
const StatsBand = lazy(() => import("@/components/landing/StatsBand").then((m) => ({ default: m.StatsBand })));
const Apps = lazy(() => import("@/components/landing/Apps").then((m) => ({ default: m.Apps })));
const BuildApp = lazy(() => import("@/components/landing/BuildApp").then((m) => ({ default: m.BuildApp })));
const Services = lazy(() => import("@/components/landing/Services").then((m) => ({ default: m.Services })));
const Manifesto = lazy(() => import("@/components/landing/Manifesto").then((m) => ({ default: m.Manifesto })));
const ServiceRequest = lazy(() => import("@/components/landing/ServiceRequest").then((m) => ({ default: m.ServiceRequest })));
const BookService = lazy(() => import("@/components/landing/BookService").then((m) => ({ default: m.BookService })));
const Footer = lazy(() => import("@/components/landing/Footer").then((m) => ({ default: m.Footer })));

const Lazy = ({ id, children }) => (
  <div id={id} className="cv-auto">
    <Suspense fallback={null}>{children}</Suspense>
  </div>
);

export default function Landing() {
  useLenis();
  return (
    <main className="bg-[#0a1526] text-white font-body">
      <Nav />
      <Hero />
      <Lazy><Ribbon /></Lazy>
      <Lazy><StatsBand /></Lazy>
      <Lazy id="services"><Services /></Lazy>
      <Lazy id="work"><Manifesto /></Lazy>
      <Lazy id="apps"><Apps /></Lazy>
      <Lazy id="build"><BuildApp /></Lazy>
      <Lazy id="book"><BookService /></Lazy>
      <Lazy id="request"><ServiceRequest /></Lazy>
      <Lazy><Footer /></Lazy>
    </main>
  );
}
